import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { AppButton } from "@/shared/components";

const Actions = styled.div<{ $compact?: boolean }>`
	margin-top: ${({ $compact }) => ($compact ? "0" : "auto")};
	padding-top: ${({ $compact }) => ($compact ? "12px" : "40px")};
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 12px;
`;

const PrimaryButton = styled(AppButton)`
	width: 100%;
	height: 47px;
	font-size: 14px;

	&:disabled {
		background: #d3d3d3;
		opacity: 1;
	}
`;

const LoginPrompt = styled.div`
	font-size: 14px;
	line-height: 24px;

	a {
		color: #3a0ca3;
		font-weight: 600;
	}
`;

interface RoleRegisterActionsProps {
	primaryLabel: string;
	primaryDisabled: boolean;
	onPrimaryClick: () => void;
	children?: ReactNode;
	compact?: boolean;
}

export const RoleRegisterActions = ({
	primaryLabel,
	primaryDisabled,
	onPrimaryClick,
	children,
	compact,
}: RoleRegisterActionsProps) => (
	<Actions $compact={compact}>
		<PrimaryButton variant="primary" disabled={primaryDisabled} onClick={onPrimaryClick}>
			{primaryLabel}
		</PrimaryButton>
		{children}
		<LoginPrompt>
			Already have an account? <Link to="/login">Log in</Link>
		</LoginPrompt>
	</Actions>
);
